
// Get active player Id from crm
export const token = (state) => state.user.token

// Get currency ISO
export const currencyIso = (state) => state.user.currency



